import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';

export const SectionContainer = styled(Box)`
  width: 100%;
  position: relative;
  min-height: 1000px;
  ${themeMediaQuery('below_sm')} {
    min-height: 850px;
  }
`;

export const TextPairingContainer = styled(TextPairing)`
  .text-pairing-body {
    max-width: 330px;
  }
`;

export const StyledTextPairFlex = styled(Flex)`
  width: 100%;
  align-items: center;
`;

export const StyledBottomCloudImage = styled(CloudImage)`
  min-height: 650px;
  max-width: 850px;
  object-fit: contain;
  z-index: 2;
  ${themeMediaQuery('below_sm')} {
    position: absolute;
    bottom: 0;
    min-width: 550px;
    min-height: 400px;
    max-width: 550px;
  }
  ${themeMediaQuery('xl')} {
    max-width: 1250px;
    min-height: 900px;
    object-fit: cover;
  }
`;

export const StyledBottomImageWrapper = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 0rem;
    padding-right: 0rem;
  }
`;

export const StyledLeftImage = styled(CloudImage)`
  position: absolute;
  width: 130.68px;
  height: 591px;
  top: 0;
  object-fit: contain;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledRightImage = styled(CloudImage)`
  position: absolute;
  width: 171px;
  height: 714px;
  bottom: 0;
  right: 0;
  object-fit: contain;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledMobileImage = styled(CloudImage)`
  position: absolute;
  width: 100%;
  bottom: 0;
  object-fit: contain;
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;
